import React, { FC } from 'react';
import Sidebar from './Layouts/Sidebar';
import { Header } from './Layouts/header';
import { Box } from '@mui/material';
import { useIsMobile } from '../hooks/useIsMobile';
import { Outlet, useLoaderData } from 'react-router-dom';
import { sendAnalyticsEvent } from '../utils/googleAnalytics';

type RootLoaderType = {
  user: any;
};


const Root: FC = () => {
  const { user } = useLoaderData() as RootLoaderType;
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const handleMenuClick = () => {
    const nextIsOpen = !isSidebarOpen;
    // GA4: ハンバーガーメニューの開閉を計測
    sendAnalyticsEvent('navigation_menu', {
      action: nextIsOpen ? 'open' : 'close',
      menu_type: 'hamburger',
    });
    setIsSidebarOpen(nextIsOpen);
  };

  return (
    <div>
      <Header
        user={user}
        onMenuClick={handleMenuClick}
        isMenuOpen={isSidebarOpen}
      />
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />
      <Box
        sx={{
          padding: '60px 0px 0px 0px',
        }}
      >
        <Box sx={{ padding: '0px 0px' }}>
          <Outlet />
        </Box>
        <footer></footer>
      </Box>
    </div>
  );
};

export default Root;
